import React, { useState, useEffect, useRef } from 'react'
import { debounce } from 'lodash'
import { Autocomplete } from '@material-ui/lab'
import { makeStyles, ListItemText, TextField } from '@material-ui/core'

const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY

const useStyles = makeStyles((theme) => ({
	autoComplete: {
		width: '100%',
		'& .MuiTextField-root': {
			minWidth: '100%'
		},
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .MuiInputLabel-filled': {
			transform: 'translate(12px, 20px) scale(1)'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	}
}))

const VetAutocomplete = (props) => {
	const classes = useStyles()
	let { onSelect, onOptionsChange, onInputChange, onOpen, onClose, value, disabled } = props

	const autoCompleteRef = useRef(null)
	const [query, setQuery] = useState('')
	const [vets, setVets] = useState([])
	const [autoCompleteService, setAutoCompleteService] = useState(null)
	const [placesService, setPlacesService] = useState(null)

	const onChangeDelayed = debounce((val) => setQuery(val), 1000)

	useEffect(() => {
		loadScript(`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places`, () =>
			handleScriptLoad(autoCompleteRef)
		)
	}, [])

	const loadScript = (url, callback) => {
		let script = document.createElement('script')
		script.type = 'text/javascript'

		if (script.readyState) {
			script.onreadystatechange = function () {
				if (script.readyState === 'loaded' || script.readyState === 'complete') {
					script.onreadystatechange = null
					callback()
				}
			}
		} else {
			script.onload = () => callback()
		}

		script.src = url
		document.getElementsByTagName('head')[0].appendChild(script)
	}

	const handleScriptLoad = (autoCompleteRef) => {
		setAutoCompleteService(new window.google.maps.places.AutocompleteService())
		setPlacesService(new window.google.maps.places.PlacesService(autoCompleteRef.current))
	}

	useEffect(() => {
		if (query) {
			let placesQuery = { input: query, types: ['establishment'] }

			autoCompleteService.getPlacePredictions({ ...placesQuery }, (predictions, status) => {
				if (status === 'OK') {
					setVets(
						predictions && predictions.length > 0
							? predictions.filter((p) => p.types.includes('veterinary_care'))
							: []
					)

					if (onOptionsChange) {
						onOptionsChange(
							predictions && predictions.length
								? predictions.filter((p) => p.types.includes('veterinary_care'))
								: []
						)
					}
				}

				if (status === 'ZERO_RESULTS') {
					if (onOptionsChange) {
						onOptionsChange([])
					}
				}
			})
		} else {
			setVets([])
		}
	}, [query])

	const getPlace = (place) => {
		if (place) {
			placesService.getDetails({ placeId: place.place_id }, (p, status) => {
				if (status === 'OK') {
					onSelect(p)
				}
			})
		}
	}

	return (
		<div>
			<Autocomplete
				size="small"
				getOptionLabel={(option) => (option && option.description ? option.description.split(',')[0] : '')}
				id="vet-select"
				className={classes.autoComplete}
				options={vets || []}
				value={value && vets && vets.length ? vets.find((v) => v.place_id === value.place_id) : ''}
				onChange={(e, v, r) =>
					r === 'clear'
						? () => {
								setVets([])
								onSelect(null)
						  }
						: getPlace(v)
				}
				onOpen={() => onOpen()}
				onClose={(e) => {
					onClose()
				}}
				onInputChange={(e, v, r) => {
					if (onInputChange && r !== 'reset') {
						onInputChange(v)
					}

					onChangeDelayed(v)
				}}
				disabled={disabled}
				renderOption={(option) => (
					<React.Fragment>
						<ListItemText primary={option.description ? option.description.split(',')[0] : ''} />
					</React.Fragment>
				)}
				noOptionsText="No Vets Found"
				renderInput={(params) => (
					<TextField {...params} inputRef={autoCompleteRef} variant="filled" label="Veterinarian" />
				)}
				onKeyPress={(e, v) => (e.key === 'Enter' ? getPlace(v) : null)}
			/>
		</div>
	)
}

export default VetAutocomplete
